import React from "react";
import CartIndex from "../components/cart";
import Footer from "../components/commonComponents/footer";
import Navbar from '../components/commonComponents/Navbar/Navbar';
import { useSelector } from "react-redux";
import PageLoader from "../common/pageLoader";

export default function Cart() {

    const { pageLoader } = useSelector(state => state.commonReducer);

    return (
        <div className={`${pageLoader && "body-overflow-hide"}`}>
            {pageLoader &&
                <PageLoader />
            }
            <Navbar />
            <CartIndex />
            <Footer />
        </div>
    )
}